import { ProductPageLayout } from '../components/ProductPageLayout';

export function AiAffiliateUnboxingAsmrPage() {
    return <ProductPageLayout productId="ai-affiliate-unboxing-asmr" />;
}
